import React from 'react';

import DiversionText from './DiversionText';
import DiversionList from './DiversionList';

class Diversion extends React.Component {
  render() {
    return (
      <div>
        <div>
          <DiversionText />
        </div>

        <div className="panel panel-default diversion-panel">
          <div className="panel-heading">
            <h3 style={{ display: 'inline' }}>Diversion related to International Transfers</h3>
          </div>
          <div className="panel-body">
            <DiversionList hasItem="hasInternationalDiversion"
                           description="descriptionInternational"
                           number="numberInternationalIncidents"/>
          </div>
        </div>
        <div className="panel panel-default diversion-panel">
          <div className="panel-heading">
            <h3 style={{ display: 'inline' }}>Diversion related to National Stockpile Management</h3>
          </div>
          <div className="panel-body">
            <DiversionList hasItem="hasStockpileDiversion"
                           description="descriptionStockpile"
                           number="numberStockpileIncidents"/>
          </div>
        </div>

      </div>
    );
  }
}

export default Diversion;



// WEBPACK FOOTER //
// ./src/components/Diversion/Diversion.js